import { createSelector } from "reselect";

export const sessionState = (state)=>{
    return  state?.sessionReducer
}

export const getSessionList = createSelector(
    sessionState,
)